import React from 'react';

import { Input, InputNumber } from 'antd';
import _ from 'lodash';

import BookerSelector from '@components/BookerSelector/BookerSelector';
import CitySelectorMulti from '@components/CitySelectorMulti/CitySelectorMulti';
import ContactDropdown from '@components/ContactDropdown/ContactDropdown';
import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import FilterDateInput from '@components/Filters/FilterDateInput';
import FilterPeriodInput from '@components/Filters/FilterPeriodInput';
import DepartmentSelector from '@components/Gui/DepartmentSelector';
import DepartmentSelectorAccountingModels from '@components/Gui/DepartmentSelectorAccounting';
import { AgencyTypeSelector } from '@components/Gui/NwForm/AgencyTypeSelector';
import AgeSelector from '@components/Gui/NwForm/AgeSelector';
import BooleanSelector from '@components/Gui/NwForm/BooleanSelector';
import CustomerTypeSelector from '@components/Gui/NwForm/CustomerTypeSelector';
import DocumentFilterSelector from '@components/Gui/NwForm/DocumentFilterSelector';
import FilterYesNoAllSelector from '@components/Gui/NwForm/FilterTypeSelector';
import { GenderSelector } from '@components/Gui/NwForm/GenderSelector';
import InputTag from '@components/Gui/NwForm/InputTag';
import InTownSelector from '@components/Gui/NwForm/InTownSelector';
import LegalStatusFilter from '@components/Gui/NwForm/LegalStatusFilter';
import LegalYearlyStatusFilter from '@components/Gui/NwForm/LegalYearlyStatusFilter';
import ModelInvoiceTypeSelector from '@components/Gui/NwForm/ModelInvoiceTypeSelector';
import ModelPlayListSelector from '@components/Gui/NwForm/ModelPlayListSelector';
import NumericRangeSelector from '@components/Gui/NwForm/NumericRangeSelector';
import SelectCountry from '@components/Gui/NwForm/SelectCountry';
import SelectCountryMulti from '@components/Gui/NwForm/SelectCountryMulti';
import StatementFilterSelector from '@components/Gui/NwForm/StatementFilterSelector';

const ContactsFilterItem = ({ filter }) => {
    const { selection, context, additional } = useContactsSelector();
    const { selectedNetworkAgencyID, selectedAccountingGroupID } = additional;
    const { itemType } = context;
    const cs_dispatch = useContactsSelectorDispatch();
    const { filters } = selection;

    let filterValue = filter.defaultval;
    const workingFilter = filters.working.find((f) => f.name === filter.name);
    if (workingFilter) {
        filterValue = workingFilter.value;
    }

    const onChange = (val) => {
        if (filter.type === 'text') {
            val = val.target.value;
        }

        let newWorkingFilters = _.clone(filters.working); //[...filters.working]
        const filterIndex = newWorkingFilters.findIndex((f) => f.name === filter.name);

        if (val) {
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    //check if array has only null values
                    if (val.every((v) => v === null)) {
                        if (filterIndex !== -1) {
                            newWorkingFilters.splice(filterIndex, 1);
                        }
                    } else {
                        if (filterIndex === -1) {
                            newWorkingFilters.push({ name: filter.name, value: val, source: 'filter' });
                        } else {
                            newWorkingFilters[filterIndex].value = val;
                        }
                    }
                } else {
                    if (filterIndex !== -1) {
                        newWorkingFilters.splice(filterIndex, 1);
                    }
                }
            } else {
                if (filterIndex === -1) {
                    newWorkingFilters.push({ name: filter.name, value: val, source: 'filter' });
                } else {
                    newWorkingFilters[filterIndex].value = val;
                }
            }
        } else {
            if (typeof val == 'boolean' && val === false) {
                if (filterIndex === -1) {
                    newWorkingFilters.push({ name: filter.name, value: false, source: 'filter' });
                } else {
                    newWorkingFilters[filterIndex].value = false;
                }
            } else {
                if (filterIndex !== -1) {
                    newWorkingFilters.splice(filterIndex, 1);
                }
            }
        }
        //updateWorkingFilters(newWorkingFilters)
        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
    };
    return (
        <>
            {filter.type === 'period' && <FilterPeriodInput value={filterValue} allowClear onChange={onChange} />}
            {filter.type === 'age-range' && <AgeSelector value={filterValue} onChange={onChange} />}
            {filter.type === 'percentage-range' && (
                <NumericRangeSelector value={filterValue} onChange={onChange} min={0} max={100} prec={0} />
            )}
            {filter.type === 'legal-status-filter' && <LegalStatusFilter value={filterValue} onChange={onChange} />}
            {filter.type === 'legal-yearly-status-filter' && (
                <LegalYearlyStatusFilter value={filterValue} onChange={onChange} />
            )}
            {filter.type === 'statement-filter' && (
                <StatementFilterSelector value={filterValue} onChange={onChange} subject={itemType} />
            )}
            {filter.type === 'booker-selector' && <BookerSelector value={filterValue} onChange={onChange} />}
            {filter.type === 'customers-type' && <CustomerTypeSelector value={filterValue} onChange={onChange} />}
            {filter.type === 'agency-type-selector' && <AgencyTypeSelector value={filterValue} onChange={onChange} />}
            {filter.type === 'contact-selector' && <ContactDropdown value={filterValue} onChange={onChange} />}
            {filter.type === 'agency-selector' && (
                <ContactDropdown value={filterValue} activeTypes={['age']} onChange={onChange} />
            )}
            {filter.type === 'filter-yes-no-all' && (
                <FilterYesNoAllSelector value={filterValue} allowClear onChange={onChange} />
            )}
            {filter.type === 'models-tag' && <InputTag value={filterValue} contactType="Model" onChange={onChange} />}
            {filter.type === 'customers-tag' && (
                <InputTag value={filterValue} contactType="Customer" onChange={onChange} />
            )}
            {filter.type === 'boolean' && <BooleanSelector value={filterValue} onChange={onChange} />}
            {filter.type === 'countries-selector' && <SelectCountryMulti value={filterValue} onChange={onChange} />}
            {filter.type === 'country-selector' && <SelectCountry value={filterValue} onChange={onChange} />}
            {filter.type === 'cities-selector' && <CitySelectorMulti value={filterValue} onChange={onChange} />}
            {filter.type === 'departments-selector' && (
                <DepartmentSelector value={filterValue} emptyValue onChange={onChange} />
            )}
            {filter.type === 'departments-selector-multi' && (
                <DepartmentSelector value={filterValue} mode="multiple" emptyValue onChange={onChange} />
            )}
            {filter.type === 'departments-selector-accounting' && (
                <DepartmentSelectorAccountingModels
                    value={filterValue}
                    emptyValue={filter.emptyValue}
                    mode={filter.mode}
                    onChange={onChange}
                    networkAgencyID={selectedNetworkAgencyID}
                />
            )}
            {filter.type === 'date' && <FilterDateInput value={filterValue} allowClear onChange={onChange} />}
            {filter.type === 'gender' && <GenderSelector value={filterValue} emptyValue onChange={onChange} />}
            {filter.type === 'intown-selector' && (
                <InTownSelector asSegmented value={filterValue} emptyValue onChange={onChange} />
            )}
            {filter.type === 'model-playlist-selector' && (
                <ModelPlayListSelector value={filterValue} onChange={onChange} />
            )}
            {filter.type === 'document-filter' && (
                <DocumentFilterSelector value={filterValue} filterType="document" emptyValue onChange={onChange} />
            )}
            {filter.type === 'playlist-filter' && (
                <DocumentFilterSelector value={filterValue} filterType="playlist" emptyValue onChange={onChange} />
            )}
            {filter.type === 'published-filter' && (
                <DocumentFilterSelector value={filterValue} filterType="published" emptyValue onChange={onChange} />
            )}
            {filter.type === 'invoice-type-selector' && (
                <ModelInvoiceTypeSelector value={filterValue} emptyValue onChange={onChange} />
            )}
            {filter.type === 'number' && <InputNumber value={filterValue} onChange={onChange} />}
            {(filter.type === '' || filter.type === 'text') && (
                <Input value={filterValue} type="text" onChange={onChange} />
            )}
        </>
    );
};

export default ContactsFilterItem;
